import { Component, Input, Output, EventEmitter } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwFabActionButton
 * @module mw.components.fab
 *
 * @param {string} [aria-label] Aria label for accessibility.
 * @param {string} [icon] String for the `<md-icon>` to be used on the action button.
 * @param {string} [tooltip-text] String to display a tooltip on hover over the action button.
 *
 * @description
 * `<mw-fab-action-button>` is a component that lives inside a `<md-fab-speed-dial>` directive which lets a user
 * select an action
 *
 * @usage
 * <hljs hljs-language="html">
 *   <mw-fab-action-button aria-label="Accessibility Label" icon="content:ic_add_24px" tooltip-text="My Tooltip Text"></mw-fab-action-button>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-fab-action-button',
    template: `
        <md-button aria-label="$ctrl.ariaLabel" class="md-fab md-raised md-mini mw-fab-action-button">
            <md-icon md-svg-src="{{$ctrl.icon}}" aria-label="$ctrl.ariaLabel"></md-icon>
            <md-tooltip md-direction="left">
                {{$ctrl.tooltipText}}
            </md-tooltip>
        </md-button>
    `
})
export class FabActionButtonComponent {
    @Input('@') ariaLabel: string;
    @Input('@') icon: string;
    @Input('@') tooltipText: string;

    constructor() {
        'ngInject';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/fab/fab-action-button.component.ts